/**
 * Internal dependencies
 */
import { OPERATORS } from './constants';

/**
 * Helper util to sort data by text fields, when sorting is done client side.
 *
 * @param {Object}   params            Function params.
 * @param {Object[]} params.data       Data to sort.
 * @param {Object}   params.view       Current view object.
 * @param {Object[]} params.fields     Array of available fields.
 * @param {string[]} params.textFields Array of the field ids to sort.
 *
 * @return {Object[]} Sorted data.
 */
export const sortByTextFields = ({
  data,
  view,
  fields,
  textFields
}) => {
  const sortedData = [...data];
  const fieldId = view.sort.field;
  if (textFields.includes(fieldId)) {
    const fieldToSort = fields.find(field => {
      return field.id === fieldId;
    });
    sortedData.sort((a, b) => {
      var _fieldToSort$getValue, _fieldToSort$getValue2;
      const valueA = (_fieldToSort$getValue = fieldToSort.getValue({
        item: a
      })) !== null && _fieldToSort$getValue !== void 0 ? _fieldToSort$getValue : '';
      const valueB = (_fieldToSort$getValue2 = fieldToSort.getValue({
        item: b
      })) !== null && _fieldToSort$getValue2 !== void 0 ? _fieldToSort$getValue2 : '';
      return view.sort.direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });
  }
  return sortedData;
};

/**
 * Helper util to get the paginated data and the paginateInfo needed,
 * when pagination is done client side.
 *
 * @param {Object}   params      Function params.
 * @param {Object[]} params.data Available data.
 * @param {Object}   params.view Current view object.
 *
 * @return {Object} Paginated data and paginationInfo.
 */
export function getPaginationResults({
  data,
  view
}) {
  const start = (view.page - 1) * view.perPage;
  const totalItems = data?.length || 0;
  data = data?.slice(start, start + view.perPage);
  return {
    data,
    paginationInfo: {
      totalItems,
      totalPages: Math.ceil(totalItems / view.perPage)
    }
  };
}
export const sanitizeOperators = field => {
  let operators = field.filterBy?.operators;
  if (!operators || !Array.isArray(operators)) {
    operators = Object.keys(OPERATORS);
  }
  return operators.filter(operator => Object.keys(OPERATORS).includes(operator));
};
//# sourceMappingURL=utils.js.map